export class MapViewSettings  {
    public centre: [number, number];
    public zoom: number;
    public baselayer: string;
    public overlays: Map<string, boolean>;    
    public opacity: number;
    public activePanel: string;
    public currentTool: string;
    public baseLayerSliderPosition: number;
    public closePanelOnBaseLayerChange: boolean;

    constructor() {
        this.centre = [-163269.4924, 6901652];
        this.zoom = 11;
        this.baselayer = "Contoured";
        this.overlays = new Map<string, boolean>();        
        this.opacity = 1.0;
        this.activePanel = null;
        this.currentTool = null;
        this.baseLayerSliderPosition = null;
        this.closePanelOnBaseLayerChange = false;
    }
}